import { render } from "./register-count.vue?vue&type=template&id=71e15b67&scoped=true"
import script from "./register-count.vue?vue&type=script&lang=js"
export * from "./register-count.vue?vue&type=script&lang=js"

import "./register-count.vue?vue&type=style&index=0&id=71e15b67&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e15b67"]])

export default __exports__